<input class="{{className}}" data-theme="explorer-fas" multiple name="files" type="file" [disabled]="disabled" accept="{{accept}}"
(change)="setPhoto($event)" id="fileInputField"  [ngClass]="{'custom-file-input': uploadType === 'croppie',
'file_upload': profilePic === true}">